/* eslint-disable react-hooks/exhaustive-deps */

import {
  Paper,
  TableCell,
  TableRow,
  Grid,
  Divider,
  LinearProgress,
} from "@material-ui/core"

import {
  Modal,
  TableCellDefault,
  DatatablesFooterServerSide,
  Loading,
  MasterButton,
  InputCheckboxMaster,
  InputOptionMaster,
  InputTextMaster,
  InputReactDatepicker,
  TableAction,
} from "App/Component/ui"
import { STYLE_DEFAULT_MASTER, TYPE_INSTANCE2 } from "App/constants"
import React, { useState, useEffect } from "react"
import {
  headCells,
  getByFilterKunjungan,
  RESET_STATE_FORM_FILTER,
  valueTypeSearch,
} from "./helpers"
import { defaultDateDisplay, defaultToastError } from "App/utils/helpers"
import { stableSort, getComparator } from "App/Component/ui/datatable/utils"
import {
  useDatatables,
  useDatatablesServerSide,
  useSelectOption,
} from "App/hooks"
import { FreezeTable } from "components/organism"
import { isNull } from "lodash"

const useStyles = STYLE_DEFAULT_MASTER

export default function ModalListKunjungan({
  setShowModal,
  setModalParent,
  handleClickSelect,
  url = "",
  type = "default",
  hardcodeFilterLayanan = false,
  nama_layanan = "",
  code_layanan = "",
  isLoadingDiskon = false,
}) {
  const classes = useStyles()
  const [rows, setRows] = useState([])
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER)
  const [totalData, setTotalData] = useState(0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    ;(async () => {
      await setNewData()
    })()
  }, [])

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit,
  ) => {
    setLoading(true)

    const res = await getByFilterKunjungan(
      {
        ...formFilter,
        typeofcare_code: hardcodeFilterLayanan
          ? code_layanan
          : formFilter.typeofcare_code,
      },
      pages,
      limit,
      url,
    )
    if (res.state) {
      setRows(res.data)
      setTotalData(res.meta.count)
      setLoading(false)
    } else {
      setRows([])
      setLoading(false)
      defaultToastError(res.message)
    }
  }

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData })

  const handleClickModal = () => {
    if (type === "default") {
      setShowModal(false)
      setModalParent(false)
    } else {
      setShowModal(false)
    }
  }
  return (
    <Modal title={"Pencarian Kunjungan"} width={"70%"} show={handleClickModal}>
      <Paper className={classes.paper}>
        <div
          style={{
            padding: "1rem",
          }}
        >
          <FormFilterKunjunganRawatJalan
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
            hardcodeFilterLayanan={hardcodeFilterLayanan}
            nama_layanan={nama_layanan}
            code_layanan={code_layanan}
          />

          <Loading show={loading} />

          {isLoadingDiskon && <LinearProgress />}

          <TableListKunjungan
            rows={rows}
            handleClickSelect={handleClickSelect}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </div>
      </Paper>
    </Modal>
  )
}

const TableListKunjungan = ({ rows, handleClickSelect }) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  })

  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}
    >
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow hover key={index}>
            <TableCell align="center">{index + 1}</TableCell>

            <TableCell align="center">
              <TableAction
                isUpdate={false}
                isDelete={false}
                isSelect={true}
                clickSelect={() => handleClickSelect(row)}
              />
            </TableCell>
            <TableCell align="left">{row?.id}</TableCell>

            <TableCell align="left">{row?.tagihan_id}</TableCell>
            <TableCell align="left">{row?.layanan_name}</TableCell>

            <TableCell align="left">
              {defaultDateDisplay(row?.date, true)}
            </TableCell>
            <TableCell align="left">
              {row?.isexternalrm ? row?.rm_name_external : row?.rm_name}
            </TableCell>
            <TableCell align="left">{row?.patients_id}</TableCell>
            <TableCell align="left">{row?.insurance_name}</TableCell>
            <TableCell align="left">{row?.company_name}</TableCell>

            <TableCell align="left">
              {row?.initial}-{row?.antrianno}
            </TableCell>
            <TableCell align="left">
              {row?.isexternalrm
                ? defaultDateDisplay(row?.date_ob_external, false)
                : defaultDateDisplay(row?.date_ob, false)}
            </TableCell>

            <TableCell align="left">{row?.umur}</TableCell>

            <TableCellDefault row={row} />
          </TableRow>
        )
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align="center" colSpan={headCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  )
}

function FormFilterKunjunganRawatJalan({
  formFilter,
  setFormFilter,
  setNewData,
  hardcodeFilterLayanan = false,
  nama_layanan = "",
  code_layanan = "",
}) {
  const layanan = useSelectOption(
    true,
    "jenis_layanan/listjenis_layanan",
    TYPE_INSTANCE2,
    "typeofcare_code",
    "name",
    "body",
  )
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    await setNewData()
  }
  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={3}>
            <InputOptionMaster
              name="type_search"
              label="KATEGORI PENCARIAN"
              id="type_search"
              withSearch={false}
              value={formFilter.type_search}
              onChange={handleChange("type_search")}
              data={valueTypeSearch}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="name"
              label="KATA KUNCI"
              id="name"
              disabled={formFilter.type_search === 0 ? true : false}
              onChange={handleChange("qword")}
              placeholder="Kata Kunci Sesuai Kategori"
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="type_rm"
              label="TYPE RM"
              id="type_rm"
              withSearch={false}
              value={formFilter.type_rm}
              onChange={handleChange("type_rm")}
              data={[
                {
                  label: "Semua",
                  value: 0,
                },
                {
                  label: "RM INTERNAL",
                  value: 1,
                },
                {
                  label: "RM EXTERNAL",
                  value: 2,
                },
              ]}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="jenis_layanan_id"
              label="JENIS LAYANAN"
              id="jenis_layanan_id"
              withSearch={true}
              data={layanan}
              disabled={hardcodeFilterLayanan}
              value={
                hardcodeFilterLayanan
                  ? code_layanan
                  : formFilter.typeofcare_code
              }
              labelValue={
                hardcodeFilterLayanan
                  ? nama_layanan
                  : formFilter.typeofcare_code_nama
              }
              onChange={(e) =>
                isNull(e)
                  ? setFormFilter({
                      ...formFilter,
                      typeofcare_code: "",
                      typeofcare_code_nama: "Pilih Tipe Layanan",
                    })
                  : setFormFilter({
                      ...formFilter,
                      typeofcare_code: e?.value,
                      typeofcare_code_nama: e?.label,
                    })
              }
            />
          </Grid>
          <Grid item sm={3}>
            <InputReactDatepicker
              selected={formFilter.first_date}
              label="TANGGAL AWAL"
              dateFormat="dd/MM/yyyy HH:mm"
              timeFormat="HH:mm"
              showTimeSelect
              timeIntervals={5}
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  first_date: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  first_date: e,
                })
              }
            />
          </Grid>

          <Grid item sm={3}>
            <InputReactDatepicker
              selected={formFilter.finish_date}
              label="TANGGAL AKHIR"
              dateFormat="dd/MM/yyyy HH:mm"
              timeFormat="HH:mm"
              showTimeSelect
              timeIntervals={5}
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  finish_date: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  finish_date: e,
                })
              }
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="doctor"
              label="DOKTER"
              id="doctor"
              value={formFilter.doctor}
              onChange={handleChange("doctor")}
              placeholder="Dokter"
            />
          </Grid>

          <Grid item sm={3}>
            <div
              style={{
                marginTop: "1.8rem",
              }}
            >
              <InputCheckboxMaster
                checked={formFilter.status}
                name="status"
                id="status"
                label="Selesai"
                onChange={() =>
                  setFormFilter({ ...formFilter, status: !formFilter.status })
                }
              />
            </div>
          </Grid>
        </Grid>
        <br />

        <div
          className="mt-1"
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <MasterButton
            name={"CARI"}
            type="submit"
            outline={true}
            color={"green"}
            size={"md"}
          />
        </div>

        <br />
        <Divider />
      </form>
    </>
  )
}
